import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PhonePromptModal from './components/PhonePromptModal';

// Auth Pages
import Landing from './pages/Landing';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyEmail from './pages/auth/VerifyEmail';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import UserManagement from './pages/admin/UserManagement';
import AstroCalendarAdmin from './pages/admin/AstroCalendarAdmin';
import UserWatchlistTracker from './pages/admin/UserWatchlistTracker';
import BatchUpload from './pages/admin/BatchUpload';
import PreOpenMarket from './pages/admin/PreOpenMarket';
import FetchStrategyData from './pages/admin/FetchStrategyData';
import DBManagement from './pages/admin/DBManagement';
import ActivityLogPage from './pages/admin/ActivityLogPage';
import ExpertViewAdmin from './pages/admin/ExpertViewAdmin';
import StrategyLibraryAdmin from './pages/admin/StrategyLibraryAdmin';
import UserMonitorPage from './pages/admin/UserMonitorPage';

// Watchlist Pages
import WatchlistManager from './pages/WatchlistManager';
import WatchlistTracker from './pages/WatchlistTracker';

// Existing App Pages (import your existing pages here)
import MarketInsight from './pages/MarketInsight';
import StockInsight from './pages/StockInsight';
import AstroInsight from './pages/AstroInsight';
import Nakshatra from './pages/Nakshatra';
import TimeTrendShift from './pages/TimeTrendShift';
import AstroCalendar from './pages/AstroCalendar';
import CsCalendar from './pages/CsCalendar';
import CasCalendar from './pages/CasCalendar';
import CombinedCalendar from './pages/CombinedCalendar';
import MarketScreener from './pages/MarketScreener';
import SectorRadar from './pages/SectorRadar';
import SectorCalendar from './pages/SectorCalendar';
import Heatmap from './pages/Heatmap';
import DailyHighlights from './pages/DailyHighlights';
import UserProfile from './pages/UserProfile';
import GannReversal from './pages/GannReversal';
import StrategyRadar from './pages/StrategyRadar';
import ChartinkWebhook from './pages/ChartinkWebhook';
import StockSummary from './pages/StockSummary';
import ResearchDesk from './pages/ResearchDesk';
import ModelPortfolio from './pages/ModelPortfolio';
import ModelPortfolioAdmin from './pages/admin/ModelPortfolioAdmin';

import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <PhonePromptModal />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Protected Routes - Market Pages */}
          <Route
            path="/market-insight"
            element={
              <ProtectedRoute requiredPage="marketOverview">
                <MarketInsight />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-insight"
            element={
              <ProtectedRoute requiredPage="stockMonitor">
                <StockInsight />
              </ProtectedRoute>
            }
          />
          <Route
            path="/heatmap"
            element={
              <ProtectedRoute requiredPage="heatmap">
                <Heatmap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/daily-snapshot"
            element={
              <ProtectedRoute requiredPage="dailyHighlights">
                <DailyHighlights />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cs-calendar"
            element={
              <ProtectedRoute requiredPage="csCalendar">
                <CsCalendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cas-calendar"
            element={
              <ProtectedRoute requiredPage="casCalendar">
                <CasCalendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/combined-calendar"
            element={
              <ProtectedRoute requiredPage="combinedCalendar">
                <CombinedCalendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/market-screener"
            element={
              <ProtectedRoute requiredPage="marketScreener">
                <MarketScreener />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sector-radar"
            element={
              <ProtectedRoute requiredPage="sectorAnalysisCS">
                <SectorRadar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sector-calendar"
            element={
              <ProtectedRoute requiredPage="sectorCalendar">
                <SectorCalendar />
              </ProtectedRoute>
            }
          />

          {/* Protected Routes - Strategy Pages */}
          <Route
            path="/gann-reversal"
            element={
              <ProtectedRoute requiredPage="swingReversal">
                <GannReversal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/strategy-radar"
            element={
              <ProtectedRoute requiredPage="strategyDashboard">
                <StrategyRadar />
              </ProtectedRoute>
            }
          />

          {/* Protected Routes - Astrology Pages */}
          <Route
            path="/astro-insight"
            element={
              <ProtectedRoute requiredPage="astrology">
                <AstroInsight />
              </ProtectedRoute>
            }
          />
          <Route
            path="/nakshatra"
            element={
              <ProtectedRoute requiredPage="astroNakshatra">
                <Nakshatra />
              </ProtectedRoute>
            }
          />

          <Route
            path="/time-trend-shift"
            element={
              <ProtectedRoute requiredPage="bhadraKaal">
                <TimeTrendShift />
              </ProtectedRoute>
            }
          />
          <Route
            path="/astro-calendar"
            element={
              <ProtectedRoute requiredPage="astroCalendar">
                <AstroCalendar />
              </ProtectedRoute>
            }
          />


          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin" requiredPage="adminPanel">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requiredRole="admin" requiredPage="adminPanel">
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/astro-calendar"
            element={
              <ProtectedRoute requiredRole="admin">
                <AstroCalendarAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/watchlist-tracker"
            element={
              <ProtectedRoute requiredRole="admin">
                <UserWatchlistTracker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/batch-upload"
            element={
              <ProtectedRoute requiredRole="admin">
                <BatchUpload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/pre-open-market"
            element={
              <ProtectedRoute requiredRole="admin">
                <PreOpenMarket />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/fetch-strategy-data"
            element={
              <ProtectedRoute requiredRole="admin">
                <FetchStrategyData />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/strategy-library"
            element={
              <ProtectedRoute requiredRole="admin">
                <StrategyLibraryAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/chartink-webhook"
            element={
              <ProtectedRoute requiredRole="admin" requiredPage="chartinkWebhook">
                <ChartinkWebhook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/db-management"
            element={
              <ProtectedRoute requiredRole="admin">
                <DBManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/activity-logs"
            element={
              <ProtectedRoute requiredRole="admin">
                <ActivityLogPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/user-monitor"
            element={
              <ProtectedRoute requiredRole="admin">
                <UserMonitorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/expert-view"
            element={
              <ProtectedRoute requiredPage="expertViewAdmin">
                <ExpertViewAdmin />
              </ProtectedRoute>
            }
          />

          {/* Watchlist Routes */}
          <Route
            path="/watchlist-manager"
            element={
              <ProtectedRoute requiredPage="watchlistManager">
                <WatchlistManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/watchlist-tracker"
            element={
              <ProtectedRoute requiredPage="watchlistTracker">
                <WatchlistTracker />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route
            path="/stock-summary"
            element={
              <ProtectedRoute requiredPage="stockSummary">
                <StockSummary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/research-desk"
            element={
              <ProtectedRoute requiredPage="expertView">
                <ResearchDesk />
              </ProtectedRoute>
            }
          />
          <Route
            path="/model-portfolio"
            element={
              <ProtectedRoute requiredPage="modelPortfolio">
                <ModelPortfolio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/model-portfolio"
            element={
              <ProtectedRoute requiredRole="admin" requiredPage="modelPortfolioAdmin">
                <ModelPortfolioAdmin />
              </ProtectedRoute>
            }
          />
          <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Navigate to="/market-insight" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
